import React from 'react';
import { useSelector } from 'react-redux';
import { Input } from '@yme/atoms/input';
import { useGoogleApi } from '@yme/hooks/useGoogleApi';
import { getCurrentCountryRoot } from '@yme/selectors/common';
import { noop } from '@yme/utils/common';
import { GoogleSearchAutocomplete } from './GoogleMapServices';
export function GoogleLocationSearch({ isRightToLeft, isInputSingle = false, googleApiKey, titleLabel, inputPlaceholderLabel, dispatchAction, isItemChosen, initialValue, value, }) {
    const currentCountry = useSelector(getCurrentCountryRoot);
    const { isLoaded } = useGoogleApi(googleApiKey);
    return (React.createElement("div", null, isInputSingle &&
        (isLoaded ? (React.createElement(GoogleSearchAutocomplete, { inputPlaceholder: inputPlaceholderLabel, isRightToLeft: isRightToLeft, currentCountry: currentCountry, dispatchAction: dispatchAction, titleLabel: titleLabel, isItemChosen: isItemChosen, initialValue: initialValue, value: value })) : (React.createElement(Input, { changeHandler: noop, name: "geolocationFieldDisabled", placeholder: inputPlaceholderLabel, isRequired: true })))));
}
GoogleLocationSearch.displayName = 'GoogleLocationSearch_Component';
